/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AttachmentReferenceType {
  invoice = 'invoice',
  bill = 'bill',
  expense = 'expense'
}

export function AttachmentReferenceTypeFromJSON(json: any): AttachmentReferenceType {
  return AttachmentReferenceTypeFromJSONTyped(json, false)
}

export function AttachmentReferenceTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AttachmentReferenceType {
  return json as AttachmentReferenceType
}

export function AttachmentReferenceTypeToJSON(value?: AttachmentReferenceType | null): any {
  return value as any
}
